<template>
  <v-container fluid>
    <v-row>
      <v-col>
        <FormKioskDevice
          :data="kiosk"
          :loading="isFormLoading"
          :disabled="isMutationLoading"
          :isNew="!id"
          @submit="onFormSubmit"
          @cancel="$router.push({ name: 'page-kiosk-devices' })"
          @delete-kiosk="deleteDevice"
          :language="language"
          @language-update="language = $event"
        />
      </v-col>
    </v-row>
    <ConfirmationDialog ref="confirmKioskRemoving" confirmText="Удалить" />
  </v-container>
</template>

<script>
import ConfirmationDialog from '@/components/confirmation-dialog'
import kioskQuery from '@/services/gql/types/Kiosk/queries/kiosk.gql'
import createKioskMutation from '@/services/gql/types/Kiosk/mutations/createKiosk.gql'
import updateKioskMutation from '@/services/gql/types/Kiosk/mutations/updateKiosk.gql'
import deleteKioskMutation from '@/services/gql/types/Kiosk/mutations/deleteKiosk.gql'
import FormKioskDevice from './form'
import { contentLocales, contentLocalesValues } from '@/configs/locales'
import { getListWithNewMainLanguage } from '@/utils/locales'
export default {
  name: 'PageKioskDevice',
  components: {
    ConfirmationDialog,
    FormKioskDevice
  },
  metaInfo () {
    return {
      title: this.id ? 'Редактировать киоск' : 'Создать киоск'
    }
  },
  props: {
    id: {
      type: String,
      default: null
    }
  },
  data () {
    return {
      language: contentLocales[0].value,
      kiosk: {}
    }
  },
  computed: {
    isFormLoading () {
      return this.$apollo.queries.kiosk.loading
    },
    isMutationLoading () {
      return this.$async.createKiosk.$pending || this.$async.updateKiosk.$pending
    }
  },
  methods: {
    onFormSubmit (formData) {
      if (!this.id) {
        this.createKiosk(formData)
      } else {
        this.updateKiosk(formData)
      }
    },
    async createKiosk (data) {
      try {
        delete data.translations
        await this.$async.createKiosk.$perform({ data })
        this.$successMsg('Киоск добавлен')
        await this.$router.push({ name: 'page-kiosk-devices' })
      } catch (e) {
        this.$handleApiError(e.graphQLErrors, 'Ошибка при добавлении киоска')
      }
    },
    async updateKiosk (data) {
      try {
        await this.$async.updateKiosk.$perform(
          {
            id: parseInt(this.id),
            data
          },
          { Language: getListWithNewMainLanguage(this.language, contentLocalesValues()) }
        )
        this.$successMsg('Киоск обновлен')
      } catch (e) {
        this.$handleApiError(e.graphQLErrors, 'Ошибка при обновлении киоска')
      }
    },
    async deleteDevice () {
      try {
        await this.$refs.confirmKioskRemoving.open()
        await this.$async.deleteKiosk.$perform({ id: parseInt(this.id) })
        this.$successMsg('Киоск удален')
      } catch (e) {
        if (e.cancel) return
        this.$handleApiError(e.graphQLErrors, `Ошибка при удалении киоска ${this.id}`)
      } finally {
        await this.$router.push({ name: 'page-kiosk-devices' })
      }
    }
  },
  apollo: {
    kiosk: {
      fetchPolicy: 'network-only',
      query: kioskQuery,
      skip () {
        return !this.id
      },
      variables () {
        return {
          where: {
            id: parseInt(this.id)
          }
        }
      },
      context () {
        return {
          headers: {
            Language: getListWithNewMainLanguage(this.language, contentLocalesValues())
          }
        }
      },
      result (res) {
        if (res.data === undefined) {
          this.$handleApiError(res.error)
          this.$router.push({ name: 'page-kiosk-devices' })
        } else {
          this.kiosk = res.data.kiosk
        }
      }
    }
  },
  async: {
    createKiosk (variables) {
      return this.$apollo.mutate({
        mutation: createKioskMutation,
        variables
      })
    },
    updateKiosk (variables, headers) {
      return this.$apollo.mutate({
        mutation: updateKioskMutation,
        variables,
        context: {
          headers
        }
      })
    },
    deleteKiosk (variables) {
      return this.$apollo.mutate({
        mutation: deleteKioskMutation,
        variables
      })
    }
  }
}
</script>
